import { Environment, type EnvironmentConfig, type IEnvironment } from 'relay-runtime';
import { defaultDataIdFromObject } from 'apollo-cache-inmemory';

import { getDefaultRelayEnvironmentConfig } from '@atlassian/relay-environment-config';
import { network } from '@confluence/relay-network/entry-points/network';

const getConfluenceDataID = (fieldValue: { [key: string]: unknown }, typeName: string) => {
	if (typeName === 'WebItem') {
		return `${fieldValue.completeKey || fieldValue.id}; ${fieldValue.url}`;
	} else if (typeName === 'OnboardingState') {
		return `${fieldValue.key}`;
	} else if (typeName === 'WebSection') {
		return `${fieldValue.cacheKey}` || `${String(fieldValue.id)}`;
	} else if (typeName === 'DetailsSummaryLines') {
		return `${fieldValue.macroId}_${fieldValue.currentPage}`;
	} else if (typeName === 'DetailLine') {
		return `${fieldValue.id}_${fieldValue.rowId}_${fieldValue.macroId}`;
	} else if (typeName === 'ConfluenceSystemTemplate') {
		return `${fieldValue.moduleCompleteKey}`;
	}

	// Ideally, we would use  RelayDataID from platform/packages/relay/relay-data-id here.
	// But this is to avoid breaking changes to cache reads via readFragment usages which specify id as a string.
	return defaultDataIdFromObject(fieldValue);
};

/**
 * Provides the relay environment config for Confluence. Currently, it is the same as the default relay environment config.
 *
 * @returns The relay environment config for Confluence.
 */
export function getConfluenceRelayEnvironmentConfig(): EnvironmentConfig {
	return getDefaultRelayEnvironmentConfig({
		getDataID: getConfluenceDataID,
		network,
	});
}

/**
 * Gets the relay environment for Confluence. This function is exported to allow the relay environment to be used in tests.
 *
 * @returns The relay environment for Confluence.
 */

let relayEnvironment: IEnvironment | null = null;
export function getRelayEnvironment(): IEnvironment {
	if (window['GLOBAL_RELAY_ENV']) {
		return window['GLOBAL_RELAY_ENV'];
	}
	if (!relayEnvironment) {
		relayEnvironment = new Environment(getConfluenceRelayEnvironmentConfig());
	}
	window['GLOBAL_RELAY_ENV'] = relayEnvironment;
	return relayEnvironment;
}
